import { UpdateUserRegistrationDocument } from "@pathwright/graphql-client/src/generated"

export default UpdateUserRegistrationDocument
